import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateItemFormAction } from '../_state/itemForm.state';
import { ItemDetailRecord } from '../types/inventoryItem';

type Props = {
  item: ItemDetailRecord | null | undefined;
};

export const usePopulateItemForm = ({ item }: Props) => {
  const populateForm = useSetAtom($populateItemFormAction);

  React.useEffect(() => {
    populateForm(item);
  }, [item, populateForm]);
};
